import { Injectable } from "@angular/core";
import { snackbarService } from "@one/web-components";

@Injectable()

export class SnackBarService {

    constructor() {
        snackbarService.setLimit(8);
    }

    showSuccess(message) {
        snackbarService.show({
            message : message,
            snackbarProps : {
                //variant: 'primary',
                status: 'positive',
                direction: 'vertical',
                showClose: true,
                elevated: false,
                duration: 5000,
                verticalPlacement: 'top',
                horizontalPlacement: 'right'
            }
        });
    }

    showError(error) {
        snackbarService.show({
            message : error,
            snackbarProps : {
                //variant: 'primary',
                status: 'alarm',
                direction: 'vertical',
                showClose: true,
                elevated: false,
                duration: 5000,
                verticalPlacement: 'top',
                horizontalPlacement: 'right',
            }
        });
    }
}